import { useState } from 'react'
import validateNewListingForm from '../data/validation/NewListingFormValidation';
import * as API from '../lib/JerseyDirectoryAPI'

const UseNewListingForm = (startPlanOption) => {

    // Holds the state value to show the new listing form or not
    const [showNewListingForm, setShowNewListingForm] = useState(false);

    // State to determine if the form has been submitted or not
    const [isSubmitted, setIsSubmitted] = useState(false);

    // State to determine if the form is being processed or not
    const [isProcessing, setIsProcessing] = useState(false);

    // State to determine if the form is successful or not
    const [isSuccessfull, setIsSuccessfull] = useState(false);

    // State for form validation errors
    const [errors, setErrors] = useState('');

    // State for API response messages
    const [apiResponseMessage, setApiResponseMessage] = useState('');

    // Derived states for showing success, errors, and loading
    const showSuccess = isSubmitted && !isProcessing && isSuccessfull;
    const showErrors = isSubmitted && !isProcessing && !isSuccessfull && errors;
    const showLoading = isSubmitted && isProcessing;


    // Holds the state value of the model that represents all fields in the form
    const [newListing, setNewListing] = useState({
        ID: '',
        planOption: startPlanOption,
        CategoryID: '',
        SubCategoryID: '',
        CustomerNumber: '',
        PositionTitle: null,
        Prefix: null,
        FirstName: null,
        LastName: null,
        OrganizationName: null,
        OwnerName: null,
        Address1: '',
        Address2: null,
        City: '',
        StateProvince: '',
        ZipCode: '',
        CountryID: '',
        LocationDescription: null,
        CowCount: null,
        PerformanceProgram: 'NONE',
        EquityInvestor: false,
        Logo: null,
        HomePhone: null,
        WorkPhone: null,
        MobilePhone: null,
        Fax: null,
        Email: null,
        WebsiteUrl: null,
        FacebookUrl: null,
        LinkedinUrl: null,
        YoutubeUrl: null,
        InstagramUrl: null,
        FarmMessage: null,
        LandingSiteType: null,
        AutoReEnroll: true,
        HeiferGrowerOnly: false,
        IsActive: false,
        ModifiedDate: null,
        ContactName1: null,
        ContactType1: null,
        ContactText1: null,
        ContactName2: null,
        ContactType2: null,
        ContactText2: null,
        ContactName3: null,
        ContactType3: null,
        ContactText3: null,
        ContactName4: null,
        ContactType4: null,
        ContactText4: null,
        Creator: '',
        Picture: null,
        CreatedOn: '',
        Notes: '',
        QueenOfQuality: false,
        SiteType: null,
    });

    // Handles the update of the values within the form model
    function handleChange(event) {
        const { name, value, type, checked } = event.target;
        const newValue = type === 'checkbox' ? checked : value;
        setNewListing(prevState => ({
            ...prevState,
            [name]: newValue
        }));
    }

    // Handles the update of the values based on the listing plan selected
    const handlePlanChange = (e) => {
        const { value } = e.target;

        if (value === 'B') {
            setNewListing((prevData) => ({
                ...prevData,
                planOption: value,
                farmMessage: '',
                landingSiteType: '',
                Picture: null,
                fileName: null,
            }));
        } else if (value === 'I') {
            setNewListing((prevData) => ({
                ...prevData,
                planOption: value,
                landingSiteType: '',
            }));
        }
    };

    // Handles the update of the values based on the listing type selected
    const handleListingTypeChange = (event) => {
        const { name, value } = event.target;
        setNewListing((prevData) => {
            const updatedData = {
                ...prevData,
                [name]: value,
            };

            if (value === '3' || value === '4') {
                return {
                    ...updatedData,
                    listingType: value,
                    FirstName: '',
                    LastName: '',
                };
            } else {
                return {
                    ...updatedData,
                    listingType: value,
                    OrganizationName: '',
                    OwnerName: '',
                };
            }
        });
    };

    // Handles the picture file change event
    const handleFileChange = async (event) => {
        try {
            const file = event.target.files[0];
            if (!file) {
                return;
            }

            // Convert the file to a byte array
            const arrayBuffer = await file.arrayBuffer();
            const byteArray = new Uint8Array(arrayBuffer);

            // Convert byte array to Base64 string
            const base64String = btoa(String.fromCharCode(...byteArray));

            setNewListing((prevState) => ({
                ...prevState,
                Picture: base64String,
                fileName: file.name,
            }));
        } catch (error) {
        }
    };

    // Handles the submission and processing of the new listing form
    const handleSubmit = (e) => {
        e.preventDefault();

        // Reset submission state
        setIsSubmitted(false);

        // Validate the form and set the validation errors
        const validationErrors = validateNewListingForm(newListing);
        setErrors(validationErrors);

        // Check if there are any non-empty error messages
        const hasErrors = Object.values(validationErrors).some(error => error !== '');

        if (!hasErrors) {
            setIsProcessing(true);

            API.createPendingListing(newListing)
                .then((res) => {
                    if (res && res.status === 201) {
                        setIsSuccessfull(true);
                        setApiResponseMessage('Listing created successfully!');
                    } else {
                        setIsSuccessfull(false);
                        setApiResponseMessage(res ? res.data : 'Unknown error');
                    }
                    setIsProcessing(false);
                })
                .catch((error) => {
                    setIsSuccessfull(false);
                    setApiResponseMessage(error.response ? error.response.data : error.message);
                    setIsProcessing(false);

                    if (error.response) {
                    }
                });
        } else {
        }

        setIsSubmitted(true);
    };

    return {
        showNewListingForm,
        isSubmitted,
        isProcessing,
        isSuccessfull,
        errors,
        apiResponseMessage,
        showSuccess,
        showErrors,
        showLoading,
        newListing,
        handleChange,
        handlePlanChange,
        handleListingTypeChange,
        handleFileChange,
        handleSubmit,
    };
};

export default UseNewListingForm;